export default function userDataSelector(func) {
  return func((state) => state.userReducer);
}
